import { useEventBus } from '@restify/packages/helpers/bus'
import { type Stores } from './useStores'

const batchBus = useEventBus<{
  'batch-add': {
    menuItem: Stores['orders']['Result']['menuItems'][number]
  }
}>('app')

export default () => batchBus